import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodDepositLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4783_426)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4783_426)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "#3B82F6",
				strokeOpacity: .32,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.8184 6.66406C31.5422 6.66415 33.7499 8.8718 33.75 11.5957V19.0303C33.75 21.1753 32.3805 22.9997 30.4678 23.6787V24.5859C30.4676 25 30.1319 25.3359 29.7178 25.3359C29.3039 25.3357 28.968 24.9999 28.9678 24.5859V23.958C28.9178 23.9595 28.8677 23.9629 28.8174 23.9629H19.1826C19.1333 23.9629 19.0842 23.9594 19.0352 23.958V24.5859C19.035 25 18.6992 25.3359 18.2852 25.3359C17.8712 25.3358 17.5354 24.9999 17.5352 24.5859V23.6797C15.6214 23.0014 14.25 21.1764 14.25 19.0303V11.5957C14.2501 8.87158 16.4589 6.66417 19.1826 6.66406H28.8184ZM24 10.4844C23.5858 10.4844 23.25 10.8202 23.25 11.2344V12.4434C22.2148 12.7136 21.402 13.5255 21.1309 14.5605H19.9238C19.5097 14.5605 19.174 14.8964 19.1738 15.3105C19.1738 15.7248 19.5096 16.0605 19.9238 16.0605H21.1289C21.398 17.099 22.2124 17.9128 23.25 18.1836V19.3887C23.25 19.8029 23.5858 20.1387 24 20.1387C24.4142 20.1387 24.75 19.8029 24.75 19.3887V18.1846C25.7887 17.9147 26.6037 17.1 26.873 16.0605H28.0791C28.4932 16.0604 28.8291 15.7247 28.8291 15.3105C28.829 14.8965 28.4931 14.5607 28.0791 14.5605H26.8711C26.5998 13.5244 25.7864 12.7117 24.75 12.4424V11.2344C24.75 10.8202 24.4142 10.4844 24 10.4844ZM24.0479 13.8457C24.8384 13.8701 25.4717 14.5174 25.4717 15.3145C25.4715 16.1266 24.8136 16.784 24.002 16.7842C23.189 16.7841 22.5305 16.1265 22.5303 15.3145C22.5303 14.5186 23.1627 13.8715 23.9531 13.8457C23.9687 13.8467 23.9842 13.8486 24 13.8486C24.0161 13.8486 24.032 13.8467 24.0479 13.8457Z",
				fill: "#3B82F6"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4783_426",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#3B82F6",
			stopOpacity: .04
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#3B82F6",
			stopOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4783_426",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodDepositLight;
